import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-yes-no-dialog',
  templateUrl: './yes-no-dialog.component.html',
  styleUrls: ['./yes-no-dialog.component.scss']
})
export class YesNoDialogComponent {

  constructor(public dialogRef: MatDialogRef<YesNoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { header: string, message: string }) {
    dialogRef.backdropClick().subscribe(() => {
      dialogRef.close(false);
    })
  }

  onNoBtnClicked() { this.dialogRef.close(false); }

  onYesBtnClicked() { this.dialogRef.close(true); }
}
